import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import {
  LocationFlag,
  InventoryStatusCell,
  NoteTooltipTableCell
} from "MODULES/shared/components";
import { INVENTORIES, REPAIR_AND_HOLD } from "MODULES/inventories/constants";
import { searchInventories as search } from "MODULES/parts/actions";
import ModifiedFlag, {
  columnStyle
} from "MODULES/parts/components/ModifiedFlag";

import { alphaMonthYear } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { NO_QUOTE } from "MODULES/OutgoingQuotes/constants";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { RepairAndHold } from "../../inventories/components/Detail/Warnings";

export class SelectInventoryTable extends Component {
  static propTypes = {
    part: PropTypes.shape({
      id: PropTypes.number.isRequired
    }),
    onInventorySelected: PropTypes.func,
    searchInventories: PropTypes.func.isRequired,
    filter: PropTypes.shape({}),
    inventoryIds: PropTypes.number,
    selectedInventory: PropTypes.shape({}),
    modal: PropTypes.bool,
    change: PropTypes.func,
    choosable: PropTypes.bool,
    displayQuantity: PropTypes.bool,
    quoteType: PropTypes.string
  };

  static defaultProps = {
    choosable: true,
    displayQuantity: true,
    onInventorySelected: () => null,
    change: () => null
  };

  state = {
    inventories: []
  };

  componentWillMount() {
    if (this.props.part) {
      this.props.change("outgoing_quote_line_item.inventory_ids", []);
      this.setInventory(this.props.part.id);
    }
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.part && nextProps.part !== this.props.part) {
      this.setInventory(nextProps.part.id, false);
    }
  }

  componentWillUnmount() {
    this.props.onInventorySelected(null);
    this.mounted = false;
  }

  setInventory = (partId, addRecord = true) => {
    const { searchInventories, filter, selectedInventory = {} } = this.props;
    this.search = searchInventories(partId, filter).then(resp => {
      if (selectedInventory.id && addRecord) {
        const containsInv = resp.some(inv => inv.id === selectedInventory.id);
        if (!containsInv) {
          resp.unshift(selectedInventory);
        }
      }
      this.updateState({ inventories: resp });
    });
  };

  updateState = nextStateUpdate => {
    if (this.mounted) {
      this.setState(nextStateUpdate);
    }
  };

  renderRow = (inventory, i, modal) => {
    const {
      choosable,
      onInventorySelected,
      inventoryIds,
      displayQuantity,
      quoteType
    } = this.props;

    return (
      <tr key={i}>
        <td style={modal ? {} : { backgroundColor: "#383838" }}>{i + 1}</td>
        {choosable && (
          <InventoryStatusCell inventory={inventory}>
            <input
              type="checkbox"
              className="radio-inline"
              checked={inventoryIds && inventoryIds.includes(inventory.id)}
              onChange={() => onInventorySelected(inventory)}
              disabled={quoteType === NO_QUOTE}
            />
          </InventoryStatusCell>
        )}
        <td>{inventory.serial_number}</td>
        <td style={columnStyle.flagColumn}>
          {inventory.modified && <ModifiedFlag />}
        </td>
        <td className="text-center">
          {_.get(INVENTORIES, `condition.${inventory.condition}.abbrev`)}
        </td>
        {displayQuantity && <td>{inventory.quantity}</td>}
        <td>
          <RepairAndHold inventory={inventory} />
          {inventory.status !== REPAIR_AND_HOLD &&
            alphaMonthYear(inventory.tag_date)}
        </td>
        <MultiLocationFeature>
          <td className="text-center">
            <LocationFlag location={inventory.store_location_id} />
          </td>
        </MultiLocationFeature>
        <td className="text-right">
          {inventory.cost_per_unit && dollars(inventory.cost_per_unit, 0)}
        </td>
        <td className="text-right">
          {inventory.exchange_srp && dollars(inventory.exchange_srp, 0)}
        </td>
        <td className="text-right">
          {inventory.suggested_retail && dollars(inventory.suggested_retail, 0)}
        </td>
        <NoteTooltipTableCell
          note={inventory.important_note}
          color="#f44336"
          className="td-shrink-icon text-left"
        />
      </tr>
    );
  };

  render() {
    const {
      inventoryIds,
      modal,
      choosable,
      onInventorySelected,
      displayQuantity
    } = this.props;
    const className = classNames("table table-striped table-numbered", {
      "table-hover": choosable
    });

    if (this.state.inventories.length === 0) {
      return (
        <div className="well well-lg text-center">No Inventory Available</div>
      );
    }

    return (
      <table className={className}>
        <thead>
          <tr>
            <th />
            {choosable && <th />}
            <th>Serial #</th>
            <th />
            <th className="text-center">CD</th>
            {displayQuantity && <th>QTY</th>}
            <th>Tag Date</th>
            <MultiLocationFeature>
              <th className="text-center">Store Loc</th>
            </MultiLocationFeature>
            <th className="text-right">Cost</th>
            <th className="text-right">Exch SRP</th>
            <th className="text-right">SRP</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {this.state.inventories.map((inv, idx) =>
            this.renderRow(inv, idx, modal)
          )}
          {choosable && (
            <tr>
              <td style={modal ? {} : { backgroundColor: "#383838" }} />
              <td className="text-center">
                <input
                  type="radio"
                  name="inventory_ids"
                  className="radio-inline"
                  checked={inventoryIds && inventoryIds.length === 0}
                  onChange={() => onInventorySelected(null)}
                />
              </td>
              <td
                colSpan="10"
                style={{ marginBottom: "2px", verticalAlign: "baseline" }}
              >
                Don&apos;t quote from a specific inventory item
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

export default connect(undefined, dispatch => ({
  searchInventories: (partId, filter) => dispatch(search(partId, filter))
}))(SelectInventoryTable);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/SelectInventoryTable.jsx